import { Fragment } from 'react';
import { Popover, Typography } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import { useGoldPrice } from '@/hooks/useGoldPrice';
import { formatNumber } from '@/utils/format';

const { Text } = Typography;

function PillBoardContent() {
  const { prices, lastUpdated, isConnected } = useGoldPrice();
  const sorted = [...prices].sort((a, b) => a.type.localeCompare(b.type));

  return (
    <div style={{ minWidth: 280 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <Text style={{ color: '#a4193d', fontWeight: 600, fontSize: 12 }}>GIÁ VÀNG HÔM NAY</Text>
        <Text style={{ fontSize: 11, color: isConnected ? '#52c41a' : '#ff4d4f' }}>
          {isConnected ? 'LIVE' : 'OFFLINE'}
        </Text>
      </div>
      {sorted.length === 0 ? (
        <Text style={{ color: '#888', fontSize: 12 }}>Chưa có dữ liệu giá vàng</Text>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto auto auto', gap: '4px 12px', fontSize: 12 }}>
          <Text style={{ color: '#888' }}>Loại</Text>
          <Text style={{ color: '#888', textAlign: 'right' }}>Mua</Text>
          <Text style={{ color: '#888', textAlign: 'right' }}>Bán</Text>
          <span />
          {sorted.map((p) => (
            <Fragment key={p.type}>
              <Text style={{ fontSize: 12 }}>{p.type}</Text>
              <Text style={{ color: '#52c41a', textAlign: 'right', fontSize: 12 }}>
                {formatNumber(p.buy)}
              </Text>
              <Text style={{ color: '#ff7a00', textAlign: 'right', fontSize: 12 }}>
                {formatNumber(p.sell)}
              </Text>
              <Text style={{ fontSize: 12, color: '#a4193d' }}>
                {p.overrideApplied ? '⁕' : ''}
              </Text>
            </Fragment>
          ))}
        </div>
      )}
      {lastUpdated && (
        <Text style={{ display: 'block', marginTop: 6, fontSize: 10, color: '#999' }}>
          Cập nhật: {new Date(lastUpdated).toLocaleTimeString('vi-VN')}
        </Text>
      )}
      <Text style={{ display: 'block', marginTop: 4, fontSize: 10, color: '#999' }}>
        ⁕ giá riêng theo cửa hàng
      </Text>
    </div>
  );
}

export function GoldPricePill() {
  const { prices, isConnected } = useGoldPrice();
  const top2 = [...prices].sort((a, b) => a.type.localeCompare(b.type)).slice(0, 2);

  return (
    <Popover content={<PillBoardContent />} trigger="click" placement="bottomRight">
      <button
        type="button"
        aria-label="Giá vàng hôm nay"
        style={{
          background: '#1a1a2e',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          padding: '4px 12px',
          height: 32,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          cursor: 'pointer',
          fontSize: 12,
        }}
      >
        <span
          style={{
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: isConnected ? '#52c41a' : '#ff4d4f',
          }}
        />
        {top2.length === 0 ? (
          <span style={{ color: '#888' }}>Đang lấy giá vàng…</span>
        ) : (
          top2.map((p, i) => (
            <span key={p.type}>
              {p.type}: {formatNumber(p.sell)}
              {i < top2.length - 1 ? <span style={{ color: '#555', margin: '0 4px' }}>│</span> : null}
            </span>
          ))
        )}
        <CaretDownOutlined style={{ fontSize: 10, opacity: 0.7 }} />
      </button>
    </Popover>
  );
}
